import { HCP_SEGMENTATION_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';
import { Filter } from '@cubejs-client/core';
import { FAIR_MARKET_VALUE_RATING_FILTER_LIMIT } from '../../filterDefaultLimits';

const FAIR_MARKET_VALUE_RATING_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.tier_fmp_level`],
  limit: FAIR_MARKET_VALUE_RATING_FILTER_LIMIT,
});

const cubeQuery = `${HCP_SEGMENTATION_CUBE_NAME}.tier_fmp_level`;

const fairMarketValueRatingFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.fairMarketValueRatingLabel',
  sourceCube: HCP_SEGMENTATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: FAIR_MARKET_VALUE_RATING_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[cubeQuery]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.fairMarketValueRatingPlaceholder',
  searchable: true,
  applyFilter: (value): Filter | undefined => {
    if (Array.isArray(value) && value.every(v => typeof v === 'string')) {
      return {
        member: cubeQuery,
        operator: 'equals',
        values: value,
      };
    }
  },
};

export default fairMarketValueRatingFilter;
